import { Route, Switch } from 'wouter'
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { ContentWrap } from '../styles/generic.styles'
import { LandingPage } from '../pages/LandingPage/LandingPage'
import { CompletePage } from '../pages/CompletePage'
import { SignicatRestrictedPage } from '../pages/SignicatRestrictedPage'
import { SettingsPage } from '../pages/SettingsPage/SettingsPage'
import { FormPage } from '../pages/FormPage/FormPage'
import { SuccessPage } from '../pages/SuccessPage'
import { ConsentPage } from '../pages/ConsentPage/ConsentPage'
import { StepsPage } from '../pages/StepsPage/StepsPage'

export const ContentRouter: React.FC = observer(() => {
  const [authorized, setAuthorized] = useState(true)

  return (
    <div className="content-router">
      <ContentWrap>
        <Switch>
          <Route
            path="/"
            component={authorized ? LandingPage : SignicatRestrictedPage}
          />
          <Route
            path="/conditions"
            component={authorized ? ConsentPage : SignicatRestrictedPage}
          />
          <Route
            path="/steps"
            component={authorized ? StepsPage : SignicatRestrictedPage}
          />
          <Route
            path="/form"
            component={authorized ? FormPage : SignicatRestrictedPage}
          />
          <Route
            path="/complete"
            component={authorized ? CompletePage : SignicatRestrictedPage}
          />
          <Route
            path="/success"
            component={authorized ? SuccessPage : SignicatRestrictedPage}
          />

          <Route path="/settings" component={SettingsPage} />

          {/* Default route in a switch */}
          <Route>
            <Route
              path="/"
              component={authorized ? LandingPage : SignicatRestrictedPage}
            />
          </Route>
        </Switch>
      </ContentWrap>
    </div>
  )
})
